export const GET_USER = "GET_USER";
export const ADD_USER_LIST = "ADD_USER_LIST";
export const ADD_USER = "ADD_USER";
export const SEARCH_USER = "SEARCH_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";

export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const NETWORK_AUTHENTICATION = "NETWORK_AUTHENTICATION";
export const TOTAL_COUNT_PAGE = "TOTAL_COUNT_PAGE";

export const GET_COMPANY = "GET_COMPANY";
export const ADD_COMPANY = "ADD_COMPANY";
export const ADD_COMPANY_LIST = "ADD_COMPANY_LIST";
export const SEARCH_COMPANY = "SEARCH_COMPANY";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";

export const CHANGE_SIGN_UP = 'CHANGE_SIGN_UP';
export const CHANGE_LOGIN = 'CHANGE_LOGIN';

export const CHANGE_SETTINGS = "CHANGE_SETTINGS"

export const GET_MEETING = "GET_MEETING";
export const ADD_MEETING = "ADD_MEETING";
export const SEARCH_MEETING = "SEARCH_MEETING";
export const UPDATE_MEETING = "UPDATE_MEETING";
export const DELETE_MEETING = "DELETE_MEETING";

export const ADD_MEMBERS_LIST = "ADD_MEMBERS_LIST";
export const ADD_ROLE_MEETING = "ADD_ROLE_MEETING";
export const ADD_DAYPLAN_MEETING = "ADD_DAYPLAN_MEETING";
export const ADD_FILENAME_MEETING = "ADD_FILENAME_MEETING";
export const DELETE_ROLE_MEETING = "DELETE_ROLE_MEETING";
export const DELETE_FILENAME_MEETING = "DELETE_FILENAME_MEETING";


export const REQUEST_START = "REQUEST_START";
export const REQUEST_ERROR = "REQUEST_ERROR";
export const REQUEST_API_ERROR = "REQUEST_API_ERROR";
export const REQUEST_CREATE_USER = "REQUEST_CREATE_USER";
export const REQUEST_DELETE_START = "REQUEST_DELETE_START";
export const REQUEST_GET_USERS_LIST_SUCCESS = "REQUEST_GET_USERS_LIST_SUCCESS";


export const AUTH_GET_CURRENT_USER_REQUEST = "AUTH_GET_CURRENT_USER_REQUEST";
export const AUTH_GET_USER_TOKEN_SUCCESS = "AUTH_GET_USER_TOKEN_SUCCESS";
export const AUTH_GET_CURRENT_USER_ERROR = "AUTH_GET_CURRENT_USER_ERROR";

export const GET_FILE = "GET_FILE";
export const UPDATE_FILE = "UPDATE_FILE";
export const DELETE_FILE = "DELETE_FILE";
export const ADD_FILE = "ADD_FILE";



